interface PaginatedResponse<T> {
  data: {
    meta: {
      hasNextPage: boolean;
      page: number;
    };
    data: T[];
  };
}

// eslint-disable-next-line unicorn/prevent-abbreviations
export const getNextPageParam = <T>(lastPage: PaginatedResponse<T>) => {
  const { page, hasNextPage } = lastPage.data.meta;
  return hasNextPage ? page + 1 : undefined;
};

export const withInfiniteQueryDefaults = <TOptions extends object>(options: TOptions) => ({
  ...options,
  getNextPageParam: (lastPage: PaginatedResponse<unknown>) => getNextPageParam(lastPage),
  initialPageParam: 1,
});
